(function () {
  function initializeMobileCollectionDescriptions() {
    if (!window.matchMedia('(max-width: 760px)').matches) return;

    var descriptions = document.querySelectorAll('.catalog-page .collection-description');

    Array.prototype.forEach.call(descriptions, function (description, index) {
      if (
        description.classList.contains('catalog-description-collapsible') ||
        description.classList.contains('early-childhood-intro') ||
        description.classList.contains('safety-mats-intro')
      ) return;

      var collapsedHeight = 150;

      if (description.scrollHeight <= collapsedHeight + 12) return;

      var descriptionId = description.id || 'CatalogCollectionDescription-' + index;
      var toggle = document.createElement('button');

      description.id = descriptionId;
      description.classList.add('catalog-description-collapsible', 'is-collapsed');

      toggle.type = 'button';
      toggle.className = 'catalog-description-toggle';
      toggle.textContent = 'Read more';
      toggle.setAttribute('aria-controls', descriptionId);
      toggle.setAttribute('aria-expanded', 'false');

      toggle.addEventListener('click', function () {
        var willExpand = description.classList.contains('is-collapsed');

        description.classList.toggle('is-collapsed', !willExpand);
        toggle.textContent = willExpand ? 'Show less' : 'Read more';
        toggle.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
      });

      description.insertAdjacentElement('afterend', toggle);
    });
  }

  function initializeCatalogSidebar() {
    if (!window.matchMedia('(min-width: 1021px)').matches) return;

    var menu = document.querySelector('.catalog-sidebar .catalog-sidebar-root > ul');
    var desiredOrder = [
      '/collections/climbing-walls',
      '/collections/outdoor-climbing',
      '/collections/indoor-jungle-gym',
      '/collections/hijinx-ninja-course',
      '/collections/hand-holds',
      '/collections/groperz',
      '/collections/early-childhood',
      '/collections/teambuilding',
      '/collections/safety-mats',
      '/collections/climbing-wall-accessories'
    ];

    if (menu) {
      Array.prototype.forEach.call(desiredOrder, function (path) {
        var items = menu.children;

        for (var itemIndex = 0; itemIndex < items.length; itemIndex++) {
          var link = items[itemIndex].querySelector(':scope > a');

          if (link && link.getAttribute('href') === path) {
            menu.appendChild(items[itemIndex]);
            break;
          }
        }
      });
    }

    var groups = document.querySelectorAll('.catalog-sidebar .children');

    Array.prototype.forEach.call(groups, function (children, index) {
      var group = children.parentElement;
      var groupLink = group.querySelector(':scope > a');

      if (!groupLink || group.classList.contains('catalog-sidebar-group')) return;

      var childrenId = 'CatalogSidebarGroup-' + index;
      var toggle = document.createElement('button');
      var opensByDefault = group.classList.contains('catalog-sidebar-default-open');

      children.id = childrenId;
      group.classList.add('catalog-sidebar-group');

      toggle.type = 'button';
      toggle.className = 'catalog-sidebar-toggle';
      toggle.setAttribute('aria-expanded', opensByDefault ? 'true' : 'false');
      toggle.setAttribute('aria-controls', childrenId);
      toggle.setAttribute(
        'aria-label',
        (opensByDefault ? 'Collapse ' : 'Expand ') + groupLink.textContent.trim()
      );

      function setGroupState(willOpen) {
        var childLinks = children.querySelectorAll('a');

        group.classList.toggle('is-open', willOpen);
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        toggle.setAttribute(
          'aria-label',
          (willOpen ? 'Collapse ' : 'Expand ') + groupLink.textContent.trim()
        );
        children.setAttribute('aria-hidden', willOpen ? 'false' : 'true');

        Array.prototype.forEach.call(childLinks, function (link) {
          link.tabIndex = willOpen ? 0 : -1;
        });
      }

      toggle.addEventListener('click', function () {
        var willOpen = !group.classList.contains('is-open');

        Array.prototype.forEach.call(
          document.querySelectorAll('.catalog-sidebar .catalog-sidebar-group.is-open'),
          function (openGroup) {
            if (openGroup !== group && openGroup._catalogSetState) {
              openGroup._catalogSetState(false);
            }
          }
        );

        setGroupState(willOpen);
      });

      group._catalogSetState = setGroupState;
      group.appendChild(toggle);
      setGroupState(opensByDefault);
    });
  }

  function initializeCatalogFeatures() {
    initializeMobileCollectionDescriptions();
    initializeCatalogSidebar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCatalogFeatures);
  } else {
    initializeCatalogFeatures();
  }
})();
